import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Modal from '../../../components/ui/Modal'; // Added Modal import

const BenefitsSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // New state for modal
  const [selectedBenefit, setSelectedBenefit] = useState(null); // New state for selected benefit

  const benefits = [
    {
      id: 1,
      icon: "Award",
      title: "Teknisi Berpengalaman 10+ Tahun",
      description: "Tim teknisi tersertifikasi dengan pengalaman menangani berbagai merk AC",
      details: [
        "Sertifikasi resmi dari HVAC Indonesia",
        "Pelatihan rutin teknologi AC terbaru", 
        "Pengalaman 10+ tahun di industri AC",
        "Menguasai semua merk: Daikin, LG, Sharp, Panasonic, dll"
      ],
      stats: "3+ Teknisi Bersertifikat"
    },
    {
      id: 2,
      icon: "DollarSign",
      title: "Harga Terjangkau dengan Garansi",
      description: "Tarif kompetitif dengan garansi kepuasan dan tanpa biaya tersembunyi",
      details: [
        "Harga tetap, tidak ada tambahan biaya",
        "Garansi perbaikan hingga 1 bulan",
        "Gratis konsultasi dan diagnosa",
        "Cicilan 0% untuk layanan premium"
      ],
      stats: "Hemat hingga 40% vs kompetitor"
    },
    {
      id: 3,
      icon: "Zap",
      title: "Layanan Cepat 24/7",
      description: "Respon cepat dalam 30 menit dan layanan darurat 24 jam setiap hari",
      details: [
        "Call center 24/7 siap melayani",
        "Teknisi standby di Area Bekasi",
        "Prioritas untuk kasus darurat",
        "Tracking real-time kedatangan teknisi"
      ],
      stats: "Rata-rata respon 25 menit"
    }
  ];

  const handleOpenModal = (benefit) => {
    setSelectedBenefit(benefit);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBenefit(null);
  };

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary/5 via-background to-secondary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-secondary/10 text-secondary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Star" size={16} className="mr-2" />
            Keunggulan Kami
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground mb-6">
            Mengapa Memilih AC Service Pro?
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
            Kami berkomitmen memberikan layanan AC terbaik dengan standar profesional 
            dan kepuasan pelanggan sebagai prioritas utama.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {benefits?.map((benefit) => (
            <div key={benefit?.id} className="bg-white rounded-2xl p-8 shadow-card hover:shadow-xl transition-all duration-300 border border-border flex flex-col justify-between">
              {/* Icon & Title */}
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mr-4 flex-shrink-0">
                  <Icon name={benefit?.icon} size={32} className="text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-bold text-xl text-foreground mb-2 leading-tight">
                    {benefit?.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {benefit?.description}
                  </p>
                </div>
              </div>

              {/* Stats */}
              <div className="bg-primary/5 rounded-xl p-4 mb-6">
                <div className="text-center">
                  <div className="text-2xl font-heading font-bold text-primary mb-1">
                    {benefit?.stats}
                  </div>
                </div>
              </div>

              {/* Expandable Details Button */}
              <div className="space-y-3">
                <Button
                  onClick={() => handleOpenModal(benefit)} // Changed onClick
                  className="w-full flex items-center justify-between p-3 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors"
                >
                  <span className="font-semibold text-foreground">Lihat Detail</span>
                  <Icon 
                    name="ChevronRight" // Changed icon to always be ChevronRight
                    size={20} 
                    className="text-primary" 
                  />
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Warranty Section */}
        <div className="bg-white rounded-2xl p-8 shadow-card border border-border">
          <div className="text-center mb-8">
            <Icon name="Shield" size={48} className="text-secondary mx-auto mb-4" />
            <h3 className="font-heading font-bold text-2xl text-foreground mb-4">
              Jaminan Kepuasan 100%
            </h3>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Kami sangat percaya diri dengan kualitas layanan kami. Jika tidak puas, 
              uang kembali 100% tanpa pertanyaan.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon name="Clock" size={24} className="text-secondary" />
              </div>
              <h4 className="font-semibold text-foreground mb-1">Garansi Waktu</h4>
              <p className="text-sm text-muted-foreground">Tepat waktu atau gratis</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon name="Wrench" size={24} className="text-secondary" />
              </div>
              <h4 className="font-semibold text-foreground mb-1">Garansi Perbaikan</h4>
              <p className="text-sm text-muted-foreground">1 bulan untuk semua layanan</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon name="DollarSign" size={24} className="text-secondary" />
              </div>
              <h4 className="font-semibold text-foreground mb-1">Garansi Harga</h4>
              <p className="text-sm text-muted-foreground">Harga tetap, tidak berubah</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon name="Heart" size={24} className="text-secondary" />
              </div>
              <h4 className="font-semibold text-foreground mb-1">Garansi Kepuasan</h4>
              <p className="text-sm text-muted-foreground">100% puas atau uang kembali</p>
            </div>
          </div>
        </div>
      </div>
      {selectedBenefit && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title={selectedBenefit.title}
        >
          <p className="text-muted-foreground mb-4">{selectedBenefit.description}</p>
          <h4 className="font-semibold text-foreground mb-2">Detail:</h4>
          <div className="space-y-2">
            {selectedBenefit.details.map((detail, index) => (
              <div key={index} className="flex items-start">
                <Icon name="CheckCircle" size={16} className="text-secondary mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-foreground">{detail}</span>
              </div>
            ))}
          </div>
          <div className="mt-4 p-3 bg-primary/5 rounded-xl text-center">
            <div className="text-lg font-heading font-bold text-primary">{selectedBenefit.stats}</div>
          </div>
        </Modal>
      )}
    </section>
  );
};

export default BenefitsSection;